export default __webpack_public_path__ + "static/Chloe-7cd830e0f361caae0b496bc98e74465a.jpg";